import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import type { Permission } from '../types/permission.type';

export type GetListPermissionResponse = ApiResponse<Permission[]>;

export const getListPermission =
  async (): Promise<GetListPermissionResponse> => {
    const url = '/permission';

    return apiClient.get(url);
  };

export const GET_LIST_PERMISSION_QUERY_KEY = 'get-list-permissions';

export const getListPermissionQueryOptions = () =>
  queryOptions({
    queryKey: [GET_LIST_PERMISSION_QUERY_KEY],
    queryFn: () => getListPermission(),
  });
